<template>
  <div class="youkeremenluxian">
    <ul>
      <li :key="index" v-for="(item, index) in showdata">
        <div class="left">top{{ index + 1 }}</div>
        <div class="right">{{ item }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "YoukeRemenLuxian",
  props: {
    chartData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      showdata: []
    };
  },
  mounted() {
    setTimeout(() => {
      let count = 0;
      let timer = setInterval(() => {
        this.showdata.push(this.chartData[count]);
        count++;
        if (count >= this.chartData.length) {
          clearInterval(timer);
        }
      }, 120);
    }, 380);
  }
};
</script>

<style scoped lang="less">
.youkeremenluxian {
  ul {
    li {
      height: 0.36rem;
      background: rgba(0, 64, 118, 0.3);
      transition: all 0.3s;
      .left {
        width: 30%;
      }
      .right {
        width: 70%;
        text-align: left;
      }
    }
    li:nth-child(even) {
      background: rgba(27, 146, 226, 0.3);
    }
    li > div {
      float: left;
      line-height: 0.36rem;
    }
  }
}
</style>
